import React from 'react';
import { getDeleteButtonConfig } from '../utils/get-delete-button-config.js';
import { CardActionBox } from '../../CardComponents/card-action-box/component.js';

var CardActions = function CardActions(_ref) {
  var cardProps = _ref.cardProps;
  var buttonConfig = cardProps.buttonConfig,
      sortableOptions = cardProps.sortableOptions;

  var _ref2 = sortableOptions || {},
      showDelete = _ref2.showDelete,
      onDelete = _ref2.onDelete;

  if (!buttonConfig && !showDelete) {
    return null;
  }

  var buttons = showDelete ? getDeleteButtonConfig(onDelete) : buttonConfig;
  return /*#__PURE__*/React.createElement(CardActionBox, {
    "data-component-type": "presentation-card-card-actions",
    chakra: 'on' // TODO remove with legacy card removal
    ,
    buttons: Array.isArray(buttons) ? buttons : [],
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  });
};

CardActions.displayName = "CardActions";
CardActions.displayName = 'CardActions';
export { CardActions };